"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVisible = exports.releaseVersionStringToDate = exports.getVersionFromApiChangeProperties = void 0;
const network_types_1 = require("@deliverr/network-types");
function getVersionFromApiChangeProperties(versioningConfig, apiChangeProperties) {
    if (apiChangeProperties.intendedVersion && versioningConfig.versions[apiChangeProperties.intendedVersion]) {
        return apiChangeProperties.intendedVersion;
    }
    else {
        return apiChangeProperties.version;
    }
}
exports.getVersionFromApiChangeProperties = getVersionFromApiChangeProperties;
/**
 * Converts a given version string to a date object.
 *
 * @param version The version string.
 * @returns A date object if a valid release version string was provided or undefined.
 */
function releaseVersionStringToDate(version) {
    const releaseVersionMatch = network_types_1.RELEASE_VERSION_REGEX.exec(version);
    if (!releaseVersionMatch) {
        return undefined;
    }
    const releaseVersionYear = +releaseVersionMatch[network_types_1.RELEASE_VERSION_REGEX_YEAR_GROUP_IDX];
    const releaseVersionMonth = +releaseVersionMatch[network_types_1.RELEASE_VERSION_REGEX_MONTH_GROUP_IDX];
    return new Date(releaseVersionYear, releaseVersionMonth - 1);
}
exports.releaseVersionStringToDate = releaseVersionStringToDate;
/**
 * Check if a requested version can access based on the configured visibility of the provided scope versions.
 * This function will NOT check if the versions provided exist and are defined in the
 * versions config file.
 *
 * @param scopeVersions: The list of versions
 * @param requestedVersion: The requested version to which should be compared to.
 * @return true if the requested versions is able to access a certain scope based on
 * the provided scoped versions.
 */
function isVisible(scopeVersions, requestedVersion) {
    return scopeVersions.some((version) => {
        if (version === requestedVersion) {
            return true;
        }
        else {
            const requestedReleaseVersionDate = releaseVersionStringToDate(requestedVersion);
            const releaseVersionDate = releaseVersionStringToDate(version);
            if (!requestedReleaseVersionDate || !releaseVersionDate) {
                return false;
            }
            return releaseVersionDate <= requestedReleaseVersionDate;
        }
    });
}
exports.isVisible = isVisible;
//# sourceMappingURL=Versioning.js.map